import {limitTo, rupiah} from 'utils/formatter'

const compare = (a, b) => {
  if (a.name < b.name) {
    return -1
  }
  if (a.name > b.name) {
    return 1
  }
  return 0
}

const orderingTaxes = (taxes) => {
  return taxes.sort(compare)
}

class ReceiptTax extends React.Component {
  render () {
    let {taxes, includeGratuityTax} = this.props
    return (<div>
      {orderingTaxes(taxes).map((tax, i) => (<div key={i}>
        <div className='pull-left'>
          { limitTo(tax.name, 25)} { tax.name.length > 25 ? '...' : '' }
          {includeGratuityTax && <span>(Included)</span>}
          {!includeGratuityTax && <span>({ tax.amount } %)</span>}
        </div>
        <div className='pull-right text-pre-wrap'>{ includeGratuityTax ? '' : this._format(tax.total)}</div>
        <div className='clearfix' />
      </div>))}
    </div>)
  }

  _format = (price) => {
    if (price > 0) {
      return rupiah(price)
    } else {
      return `(${rupiah(-1 * price)})`
    }
  }
}

ReceiptTax.propTypes = {
  taxes: React.PropTypes.array,
  includeGratuityTax: React.PropTypes.bool
}

export default ReceiptTax



// WEBPACK FOOTER //
// ./app/components/receipt/commons/CountingBox/ReceiptTax/ReceiptTax.js